import { createFileRoute } from "@tanstack/react-router"
import { ReactElement } from "react"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

import { AdminPostUsageList } from "~/components/Admin/AdminPostUsageList"

function AdminUserUsage() {
  const { id: teamId } = Route.useParams()

  return (
    <>
      <AdminPostUsageList teamId={teamId} />
    </>
  )
}

function AdminUserUsageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminUserUsage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/team/$id")({
  component: AdminUserUsageWrapper,
})
